<script setup lang="ts">
import {
  Button,
  ButtonColor,
  ButtonSize,
  Card,
  CardActions,
} from '@exfluential/ui';
import { computed } from 'vue';
import { DashboardSpotlightConfigDto } from '~/api/dashboard';
import { perceivedBrightness } from '~/utils/colors';

type Props = {
  spotlight: DashboardSpotlightConfigDto;
};

const props = defineProps<Props>();

const customStyle = computed(() => {
  const { backgroundColor } = props.spotlight;
  if (!backgroundColor) return null;
  const textColor =
    props.spotlight.textColor ??
    (perceivedBrightness(backgroundColor) > 150 ? '#000000' : '#ffffff');
  return { backgroundColor, color: textColor };
});
</script>

<template>
  <Card
    interactive
    class="justify-between"
    :class="customStyle ? '' : 'bg-secondary text-on-secondary'"
    :style="customStyle ?? undefined"
  >
    <div>
      <div class="text-heading-lg">{{ spotlight.title }}</div>
      <div v-if="spotlight.description" class="mt-lg text-body-md">
        {{ spotlight.description }}
      </div>
    </div>

    <CardActions v-if="spotlight.ctaUrl && spotlight.ctaLabel">
      <template #start>
        <Button
          :label="spotlight.ctaLabel"
          :to="spotlight.ctaUrl"
          :size="ButtonSize.SM"
          :color="ButtonColor.SURFACE_CONTAINER"
        />
      </template>
    </CardActions>
  </Card>
</template>
